export default {
    token: {},
    versionValue: process.env.VUE_APP_VERSION,
    urlAPI: process.env.VUE_APP_URL_API,
    urlAPIEstabelecimento: process.env.VUE_APP_URL_API_ESTABELECIMENTO,
    urlAPIMensagens: process.env.VUE_APP_URL_API_MENSAGENS,
    urlAPIAmbiencia: process.env.VUE_APP_URL_API_AMBIENCIA,
    csTipoUepDashboard: '*',
    extensionistas: [],
    isLoadingExtensionistas: false,
    cdResponsavelTecnicoDashboard: undefined,
    dadosDashboard: {
        plantel: '',
        mortalidadeStr: '',
        alojados_lotes_aberto: '',
        total_lotes_aberto: '',
        alojados_lotes_aberto_semana: [],
        baixas_lotes_aberto_semana: [],
        ultimas_baixas: [],
    },
    isLoadingDadosDashboard: false,
    estabelecimentos: [],
    isLoadingEstabelecimentos: false,
    paises: [],
    isLoadingPaises: false,
    ufs: [],
    isLoadingUFs: false,
    municipios: [],
    isLoadingMunicipios: false,
    tiposUnidadesExploracao: [
        {
            csTipoUnidadeExploracao: 'UP',
            dsTipoUnidadeExploracao: 'UPL'
        },
        {
            csTipoUnidadeExploracao: 'CR',
            dsTipoUnidadeExploracao: 'Creche'
        },
        {
            csTipoUnidadeExploracao: 'TR',
            dsTipoUnidadeExploracao: 'Terminação'
        },
        {
            csTipoUnidadeExploracao: 'WF',
            dsTipoUnidadeExploracao: 'Wean to Finish'
        }
    ],
    tiposUnidadesExploracaoSemUpl: [
        {
            csTipoUnidadeExploracao: 'CR',
            dsTipoUnidadeExploracao: 'Creche'
        },
        {
            csTipoUnidadeExploracao: 'TR',
            dsTipoUnidadeExploracao: 'Terminação'
        },
        {
            csTipoUnidadeExploracao: 'WF',
            dsTipoUnidadeExploracao: 'Wean to Finish'
        }
    ],
    fabricasRacao: [],
    isLoadingFabricasRacao: false,
    statusPedidoRacao: [],
    isLoadingStatusPedidoRacao: false,
    racoes: [],
    isLoadingRacoes: false,
    laboratorios: [],
    isLoadingLaboratorios: false,
    principiosAtivos: [],
    isLoadingPrincipiosAtivos: false,
    plantasAbate: [],
    isLoadingPlantasAbate: false,
    motivosBaixa: [],
    isLoadingMotivosBaixa: false,
    filtroLoteProducao: {
        nmProdutorSearch: '',
        nrPavilhaoSearch: '',
        dtInicioAlojamentoSearch: '',
        dtFimAlojamentoSearch: '',
        csStatusLoteSearch: 'AB',
        csGeneroLoteSearch: '',
        csTipoLoteSearch: '',
        nrControleSearch: '',
        cdResponsavelTecnicoSearch: 0,
        nrMortalidadeMinSearch: '',
        nrMortalidadeMaxSearch: '',
        nrConsumoMinSearch: '',
        nrConsumoMaxSearch: '',
        page: 1,
        totalLotes: 0,
    },
    lotesProducao: [],
    isLoadingLotesProducao: false,
    loteProducaoAtual: {},
    tabelasConsumoRacao: [],
    isLoadingTabelasConsumoRacao: false,
    tabelaConfiguracao: [],
    isLoadingTabelaConfiguracao: false,
    tabelasMetaMortalidade: [],
    isLoadingTabelasMetaMortalidade: false,
    tiposFarmaco: [],
    isLoadingTiposFarmaco: false,
    farmacos: [],
    isLoadingFarmacos: false,
    lstSinalClinico: [],
    isLoadingSinalClinico: false,
    tabelaCrescimentoAnimal: {
        4: [
            {
                nrSemana: 1,
                nrDias: 7,
                qtPeso: 2.9,
                qtGpd: 0.2
            },
            {
                nrSemana: 2,
                nrDias: 14,
                qtPeso: 4.3,
                qtGpd: 0.2
            },
            {
                nrSemana: 3,
                nrDias: 21,
                qtPeso: 6.2,
                qtGpd: 0.27
            },
            {
                nrSemana: 4,
                nrDias: 28,
                qtPeso: 8.5,
                qtGpd: 0.33
            },
            {
                nrSemana: 5,
                nrDias: 35,
                qtPeso: 11.1,
                qtGpd: 0.37
            },
            {
                nrSemana: 6,
                nrDias: 42,
                qtPeso: 14.2,
                qtGpd: 0.44
            },
            {
                nrSemana: 7,
                nrDias: 49,
                qtPeso: 17.8,
                qtGpd: 0.51
            },
            {
                nrSemana: 8,
                nrDias: 56,
                qtPeso: 21.9,
                qtGpd: 0.59
            },
            {
                nrSemana: 9,
                nrDias: 63,
                qtPeso: 26.3,
                qtGpd: 0.63
            },
            {
                nrSemana: 10,
                nrDias: 70,
                qtPeso: 31,
                qtGpd: 0.67
            },
            {
                nrSemana: 11,
                nrDias: 77,
                qtPeso: 36.1,
                qtGpd: 0.73
            },
            {
                nrSemana: 12,
                nrDias: 84,
                qtPeso: 41.7,
                qtGpd: 0.8
            },
            {
                nrSemana: 13,
                nrDias: 91,
                qtPeso: 47.7,
                qtGpd: 0.86
            },
            {
                nrSemana: 14,
                nrDias: 98,
                qtPeso: 53.9,
                qtGpd: 0.89
            },
            {
                nrSemana: 15,
                nrDias: 105,
                qtPeso: 60.3,
                qtGpd: 0.91
            },
            {
                nrSemana: 16,
                nrDias: 112,
                qtPeso: 67,
                qtGpd: 0.96
            },
            {
                nrSemana: 17,
                nrDias: 119,
                qtPeso: 73.9,
                qtGpd: 0.99
            },
            {
                nrSemana: 18,
                nrDias: 126,
                qtPeso: 80.8,
                qtGpd: 0.99
            },
            {
                nrSemana: 19,
                nrDias: 133,
                qtPeso: 87.8,
                qtGpd: 1
            },
            {
                nrSemana: 20,
                nrDias: 140,
                qtPeso: 94.9,
                qtGpd: 1.01
            },
            {
                nrSemana: 21,
                nrDias: 147,
                qtPeso: 101.9,
                qtGpd: 1
            },
            {
                nrSemana: 22,
                nrDias: 154,
                qtPeso: 109,
                qtGpd: 1.01
            },
            {
                nrSemana: 23,
                nrDias: 167,
                qtPeso: 115.9,
                qtGpd: 0.99
            },
            {
                nrSemana: 24,
                nrDias: 168,
                qtPeso: 122.5,
                qtGpd: 0.96
            },
            {
                nrSemana: 25,
                nrDias: 175,
                qtPeso: 128.8,
                qtGpd: 0.9
            },
            {
                nrSemana: 26,
                nrDias: 182,
                qtPeso: 134.6,
                qtGpd: 0.83
            },
            {
                nrSemana: 27,
                nrDias: 189,
                qtPeso: 139.9,
                qtGpd: 0.76
            },
            {
                nrSemana: 28,
                nrDias: 196,
                qtPeso: 144.4,
                qtGpd: 0.64
            },
            {
                nrSemana: 29,
                nrDias: 203,
                qtPeso: 148.3,
                qtGpd: 0.56
            },
            {
                nrSemana: 30,
                nrDias: 210,
                qtPeso: 151.3,
                qtGpd: 0.43
            }
        ],
        6: [
            {
                nrSemana: 1,
                nrDias: 7,
                qtPeso: 2.74,
                qtGpd: 0.205
            },
            {
                nrSemana: 2,
                nrDias: 14,
                qtPeso: 4.32,
                qtGpd: 0.239
            },
            {
                nrSemana: 3,
                nrDias: 21,
                qtPeso: 6.11,
                qtGpd: 0.270
            },
            {
                nrSemana: 4,
                nrDias: 28,
                qtPeso: 8.14,
                qtGpd: 0.306
            },
            {
                nrSemana: 5,
                nrDias: 35,
                qtPeso: 10.46,
                qtGpd: 0.351
            },
            {
                nrSemana: 6,
                nrDias: 42,
                qtPeso: 13.13,
                qtGpd: 0.407
            },
            {
                nrSemana: 7,
                nrDias: 49,
                qtPeso: 16.24,
                qtGpd: 0.473
            },
            {
                nrSemana: 8,
                nrDias: 56,
                qtPeso: 19.85,
                qtGpd: 0.547
            },
            {
                nrSemana: 9,
                nrDias: 63,
                qtPeso: 23.9,
                qtGpd: 0.627
            },
            {
                nrSemana: 10,
                nrDias: 70,
                qtPeso: 28.7,
                qtGpd: 0.708
            },
            {
                nrSemana: 11,
                nrDias: 77,
                qtPeso: 33.98,
                qtGpd: 0.788
            },
            {
                nrSemana: 12,
                nrDias: 84,
                qtPeso: 39.8,
                qtGpd: 0.863
            },
            {
                nrSemana: 13,
                nrDias: 91,
                qtPeso: 46.12,
                qtGpd: 0.932
            },
            {
                nrSemana: 14,
                nrDias: 98,
                qtPeso: 52.89,
                qtGpd: 0.991
            },
            {
                nrSemana: 15,
                nrDias: 105,
                qtPeso: 60.03,
                qtGpd: 1.040
            },
            {
                nrSemana: 16,
                nrDias: 112,
                qtPeso: 67.47,
                qtGpd: 1.078
            },
            {
                nrSemana: 17,
                nrDias: 119,
                qtPeso: 75.12,
                qtGpd: 1.103
            },
            {
                nrSemana: 18,
                nrDias: 126,
                qtPeso: 82.90,
                qtGpd: 1.117
            },
            {
                nrSemana: 19,
                nrDias: 133,
                qtPeso: 90.73,
                qtGpd: 1.119
            },
            {
                nrSemana: 20,
                nrDias: 140,
                qtPeso: 98.54,
                qtGpd: 1.111
            },
            {
                nrSemana: 21,
                nrDias: 147,
                qtPeso: 106.25,
                qtGpd: 1.093
            },
            {
                nrSemana: 22,
                nrDias: 154,
                qtPeso: 113.79,
                qtGpd: 1.066
            },
            {
                nrSemana: 23,
                nrDias: 162,
                qtPeso: 122.15,
                qtGpd: 1.027
            },
            {
                nrSemana: 24,
                nrDias: 169,
                qtPeso: 129.18,
                qtGpd: 0.985
            },
            {
                nrSemana: 25,
                nrDias: 174,
                qtPeso: 134,
                qtGpd: 0.951
            }
        ],
        8: [
            {
                nrSemana: 1,
                nrDias: 7,
                qtPeso: 2.9,
                qtGpd: 0.2
            },
            {
                nrSemana: 2,
                nrDias: 14,
                qtPeso: 4.3,
                qtGpd: 0.2
            },
            {
                nrSemana: 3,
                nrDias: 21,
                qtPeso: 6.2,
                qtGpd: 0.27
            },
            {
                nrSemana: 4,
                nrDias: 28,
                qtPeso: 8.5,
                qtGpd: 0.33
            },
            {
                nrSemana: 5,
                nrDias: 35,
                qtPeso: 11.1,
                qtGpd: 0.37
            },
            {
                nrSemana: 6,
                nrDias: 42,
                qtPeso: 14.2,
                qtGpd: 0.44
            },
            {
                nrSemana: 7,
                nrDias: 49,
                qtPeso: 17.8,
                qtGpd: 0.51
            },
            {
                nrSemana: 8,
                nrDias: 56,
                qtPeso: 21.9,
                qtGpd: 0.59
            },
            {
                nrSemana: 9,
                nrDias: 63,
                qtPeso: 26.3,
                qtGpd: 0.63
            },
            {
                nrSemana: 10,
                nrDias: 70,
                qtPeso: 31,
                qtGpd: 0.67
            },
            {
                nrSemana: 11,
                nrDias: 77,
                qtPeso: 36.1,
                qtGpd: 0.73
            },
            {
                nrSemana: 12,
                nrDias: 84,
                qtPeso: 41.7,
                qtGpd: 0.8
            },
            {
                nrSemana: 13,
                nrDias: 91,
                qtPeso: 47.7,
                qtGpd: 0.86
            },
            {
                nrSemana: 14,
                nrDias: 98,
                qtPeso: 53.9,
                qtGpd: 0.89
            },
            {
                nrSemana: 15,
                nrDias: 105,
                qtPeso: 60.3,
                qtGpd: 0.91
            },
            {
                nrSemana: 16,
                nrDias: 112,
                qtPeso: 67,
                qtGpd: 0.96
            },
            {
                nrSemana: 17,
                nrDias: 119,
                qtPeso: 73.9,
                qtGpd: 0.99
            },
            {
                nrSemana: 18,
                nrDias: 126,
                qtPeso: 80.8,
                qtGpd: 0.99
            },
            {
                nrSemana: 19,
                nrDias: 133,
                qtPeso: 87.8,
                qtGpd: 1
            },
            {
                nrSemana: 20,
                nrDias: 140,
                qtPeso: 94.9,
                qtGpd: 1.01
            },
            {
                nrSemana: 21,
                nrDias: 147,
                qtPeso: 101.9,
                qtGpd: 1
            },
            {
                nrSemana: 22,
                nrDias: 154,
                qtPeso: 109,
                qtGpd: 1.01
            },
            {
                nrSemana: 23,
                nrDias: 167,
                qtPeso: 115.9,
                qtGpd: 0.99
            },
            {
                nrSemana: 24,
                nrDias: 168,
                qtPeso: 122.5,
                qtGpd: 0.96
            },
            {
                nrSemana: 25,
                nrDias: 175,
                qtPeso: 128.8,
                qtGpd: 0.9
            },
            {
                nrSemana: 26,
                nrDias: 182,
                qtPeso: 134.6,
                qtGpd: 0.83
            },
            {
                nrSemana: 27,
                nrDias: 189,
                qtPeso: 139.9,
                qtGpd: 0.76
            },
            {
                nrSemana: 28,
                nrDias: 196,
                qtPeso: 144.4,
                qtGpd: 0.64
            },
            {
                nrSemana: 29,
                nrDias: 203,
                qtPeso: 148.3,
                qtGpd: 0.56
            },
            {
                nrSemana: 30,
                nrDias: 210,
                qtPeso: 151.3,
                qtGpd: 0.43
            }
        ]
    },
    tiposGenero: [
        {
            sgSexo: 'MA',
            dsSexo: 'Macho'
        },
        {
            sgSexo: 'FE',
            dsSexo: 'Fêmea'
        },
        {
            sgSexo: 'MI',
            dsSexo: 'Misto'
        }
    ],
    listaGeneros: [
        {
            'sgGenero': 'MA',
            'dsGenero': 'Macho'
        },
        {
            'sgGenero': 'FE',
            'dsGenero': 'Fêmea'
        }
    ],
    tiposCaminhao: [],
    isLoadingTiposCaminhao: false,
    tiposAdmFarmaco: [],
    isLoadingTiposAdmFarmaco: false,
}